import React from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { motion } from "framer-motion";
import { ArtworkCard } from "../components/ArtworkCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EverybodyLooksPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["collection", "everybody-looks"],
    queryFn: async () => (await axios.get(`${API}/collections/everybody-looks`)).data.artworks,
  });

  const artworks = data || [];

  return (
    <div className="min-h-screen" data-testid="collection-everybody-looks-page" style={{ background: "#FBF3DC" }}>
      <div className="pt-32 pb-24 px-6 sm:px-12 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-14 text-center"
        >
          <p className="font-mono-accent text-[11px] uppercase tracking-[0.35em] text-[#C9501C] mb-4">
            The Everybody Looks Collection
          </p>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#C9501C]">
            Everybody Looks
          </h1>
        </motion.div>

        {isLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12" data-testid="collection-loading">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="aspect-[4/5] bg-[#F8EDDA] animate-pulse border border-[rgba(42,33,24,0.06)]" />
            ))}
          </div>
        ) : artworks.length === 0 ? (
          <div className="py-24 text-center" data-testid="collection-empty">
            <p className="font-serif-display italic text-2xl text-[#AB9C86]">
              The collection is coming soon.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12" data-testid="collection-grid">
            {artworks.map((art, i) => (
              <ArtworkCard key={art.id} artwork={art} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
